<template>
    <div
        v-tooltip="{content: isActive ? 'Unlike' : 'Like', hideOnTargetClick: false}"
        aria-label="Favorite"
        @click="toggle"
    >
        <i
            class="fa-thumbs-up"
            :class="isActive ? 'fad' : 'fal'"
        />
    </div>
</template>

<script>
export default {
    name: 'LikeAction',
    props: {
        isLiked: {
            type: Boolean,
            required: true,
        },
        itemId: {
            required: true,
        },
    },
    data() {
        return {
            isActive: false,
        };
    },
    mounted() {
        if (this.isLiked) {
            this.isActive = true;
        }
    },
    methods: {
        toggle() {
            axios.post('/api/article-likes/toggle', { article_id: this.itemId })
                .then((response) => {
                    if (response.data.success) {
                        this.isActive = response.data.isSaved;
                    }
                })
                .catch((e) => console.log(e));
        },
    },
};
</script>
